import MuscleBackendManager from "@lib/data/templates/backend-manager.class";
import axios from "axios";
class ProviderManager extends MuscleBackendManager {
  constructor() {
    super(process.env.NEXT_PUBLIC_MUSCLE_CUSTOMERS_API);
  }
  async getProviderToken() {
    const axios = this.getAxiosInstance();
    const res = await axios.get("/auth/bank/token");
    if (res.status !== 200) {
      throw new Error("Error fetching token");
    }
    return res.data;
  }
  async getProviderRegisterToken() {
    const axios = this.getAxiosInstance();
    const res = await axios.get("/auth/bank/benefit_new_account_token");
    if (res.status !== 200) {
      throw new Error("Error fetching token");
    }
    return res.data;
  }

  /**
   *
   * @deprecated  use wrapped js route instead for move the cache of the guest user to the real one
   * @param code
   * @param userId
   * @returns
   */
  async callbackProvider(code, userId) {
    var _process$env$NEXT_PUB;
    const params = new URLSearchParams({
      code: encodeURIComponent(code),
      customerId: encodeURIComponent(userId),
      format: "json"
    });
    let route = "customer_users/auth/benefit/callback?".concat(params.toString());
    const baseUrl = ((_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_MUSCLE_CUSTOMERS_API) === null || _process$env$NEXT_PUB === void 0 ? void 0 : _process$env$NEXT_PUB.replace("/api/v1", "")) || "";
    route = "".concat(baseUrl, "/").concat(route);
    try {
      const response = await axios.post(route, undefined, {
        headers: {
          "X-Api-Key": "no-auth"
        }
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  }
  async validateProviderSession() {
    const axios = this.getAxiosInstance();
    const res = await axios.post("/auth/bank/sync");
    if (res.status !== 200) {
      throw new Error("Error fetching provider token");
    }
    return res.data;
  }
}
const providerManager = new ProviderManager();
export default providerManager;